<template>
  <div class="dgs chat grid-gua paper-grain" data-product="heart">
    <div class="sheet">
      <div class="top">
        <div class="masthead">
          <div class="kicker">AI · 财 · 印 · 识人</div>
          <h1>{{ routeName }}</h1>
          <div class="sub" v-if="detailList.length > 0">已追问 {{ detailList.length - 1 }}/5</div>
          <div class="rule"></div>
        </div>
      </div>

      <div v-if="detailList.length > 0" class="content">
        <!-- 聊天截图（仅第一条记录展示） -->
        <div v-if="detailList[0].images && detailList[0].images.length > 0" class="card mt-4">
          <div class="card-title"><span class="dot"></span>聊天截图</div>
          <div class="thumb-strip">
            <div
              v-for="(img, imgIdx) in getDisplayImages(detailList[0].images)"
              :key="imgIdx"
              class="tshot"
              @click="previewImage(detailList[0].images, imgIdx)"
            >
              <img :src="img" class="thumb-img" alt="" />
              <span class="n">{{ imgIdx + 1 }}</span>
            </div>
          </div>
        </div>

        <!-- 遍历展示所有记录 -->
        <div v-for="(item, idx) in detailList" :key="idx" class="card mt-3 detail-card">
          <!-- 印章（仅首次分析显示） -->
          <div v-if="idx === 0" class="seal sm stamp" title="AI 财印识人">识</div>

          <div class="qhead">
            <span v-if="idx === 0" class="chip seal">问 {{ idx + 1 }} · 首次分析</span>
            <span v-else class="chip">问 {{ idx + 1 }} · 追问</span>
          </div>

          <div class="qbox">{{ item.prompt }}</div>

          <div v-if="item.text" class="md" v-html="renderMarkdown(item.text)"></div>
        </div>

        <!-- 继续追问 -->
        <div class="card mt-3">
          <div class="card-title"><span class="dot"></span>继续追问</div>
          <div v-if="detailList.length >= 5" class="limit-note">
            追问次数已达上限（最多5次），无法继续提问
          </div>
          <template v-else>
            <div class="field">
              <label>还有什么想问的</label>
              <textarea
                class="control ta"
                rows="3"
                v-model="newPrompt"
                placeholder="例如：那我该怎么回她？"
              ></textarea>
            </div>
            <van-button
              :loading="loading"
              loading-text="请求中..."
              class="btn btn-seal btn-block mt-2"
              @click="onSubmitPrompt"
            >提交追问</van-button>
            <div class="count-note">已追问 {{ detailList.length - 1 }}/5 · 还剩 {{ 5 - (detailList.length - 1) }} 次</div>
          </template>
        </div>

        <div class="foot">
          <img src="../assets/qrcode.jpg" class="qr" alt="">
          <p>想了解更多性格分析 · 长按二维码关注：喵星君大大</p>
        </div>
      </div>

      <div v-else-if="loading" class="empty-state">
        加载中...
      </div>
      <div v-else class="empty-state">
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, ImagePreview } from 'vant'
import { postAction } from '@/api/manage'

export default {
  name: 'ChatDetail',
  data() {
    return {
      detailList: [],
      newPrompt: '',
      loading: false,
      pay: '1',
    }
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {}
    },
    openid() {
      return this.userinfoLove.jsopenid
    },
    unionid() {
      return this.userinfoLove.unionid
    },
    code() {
      return this.$route.query.code ? this.$route.query.code : ''
    },
    routeName() {
      return this.$route.query.name || ''
    },
    routeSessionId() {
      return this.$route.query.session_id || ''
    },
    routeIndex() {
      return this.$route.query.index !== undefined ? Number(this.$route.query.index) : 0
    },
  },
  mounted() {
    // 本地调试：自动注入 mock 用户数据
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.$store.commit('setUserInfoLove', {
        unionid: 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
        jsopenid: 'mock_openid_67890',
        nickname: '测试用户',
        image: ''
      })
      this.getDetail()
      return
    }
    if (!this.unionid) {
      if (!this.code) {
        var url = encodeURIComponent(window.location.protocol + '//' + window.location.hostname + '/chatDetail')
        var query = ''
        if (this.routeName) query += '&name=' + encodeURIComponent(this.routeName)
        if (this.routeSessionId) query += '&session_id=' + encodeURIComponent(this.routeSessionId)
        if (query) url += '?' + query.substring(1)
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        this.getJsLogin()
      }
    } else {
      this.getDetail()
    }
  },
  methods: {
    getJsLogin() {
      const url = '/xcxlove/double/jslogin'
      postAction(url, { code: this.code }).then(res => {
        if (res.data.code == 200 || res.data.code == 400) {
          this.userInfo = res.data.msg
          this.$store.commit('setUserInfoLove', this.userInfo)
          this.getDetail()
        }
      })
    },
    getDetail() {
      this.loading = true
      const url = '/chat/detail'
      const params = {
        unionid: this.unionid,
        pay: this.pay,
        name: this.routeName,
      }
      postAction(url, params).then(res => {
        if (res.data.code == 200) {
          const msg = res.data.msg
          if (Array.isArray(msg) && msg.length > 0) {
            // 保存整个列表，用于展示所有记录
            this.detailList = msg
          } else {
            this.detailList = []
          }
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 获取显示的图片URL列表
    getDisplayImages(images) {
      if (!images) return []
      return images.map(img => this.getFullUrl(img))
    },
    previewImage(images, index) {
      const displayImages = this.getDisplayImages(images)
      ImagePreview({
        images: displayImages,
        startPosition: index,
        closeable: true,
      })
    },
    onSubmitPrompt() {
      console.log('onSubmitPrompt called')
      console.log('detailList length:', this.detailList.length)
      console.log('newPrompt:', this.newPrompt)
      
      if (this.detailList.length >= 5) {
        Toast.fail('追问次数已达上限（最多5次）')
        return
      }
      if (!this.newPrompt) {
        Toast.fail('请输入问题')
        return
      }
      this.loading = true
      const url = '/chat/analyze'
      // 使用第一条记录的图片和session_id
      const firstItem = this.detailList[0] || {}
      const imageList = (firstItem.images || []).map(img => this.getFileName(img))
      postAction(url, {
        unionid: this.unionid,
        pay: '1',
        name: firstItem.name || this.routeName,
        prompt: this.newPrompt,
        image_list: imageList,
        session_id: firstItem.session_id || this.routeSessionId,
      }).then(res => {
        if (res.data.code == 200) {
          Toast.success(res.data.msg || '提交成功')
          this.$router.push({ path: '/chatList' })
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 从URL或路径中提取文件名
    getFileName(url) {
      if (!url) return ''
      return url.substring(url.lastIndexOf('/') + 1)
    },
    // 文件名拼接完整访问URL，已是完整URL则原样返回
    getFullUrl(img) {
      if (!img) return ''
      if (img.indexOf('http') === 0 || img.indexOf('//') === 0) return img
      return 'http://www.miaoxingjundd.com/chat/' + img
    },
    // 简易 markdown 渲染
    renderMarkdown(text) {
      if (!text) return ''
      // 转义 HTML 特殊字符
      let html = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

      // 表格处理 | col | col |
      const lines = html.split('\n')
      let result = []
      let inTable = false
      let tableHtml = ''
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim()
        // 表格行
        if (line.startsWith('|') && line.endsWith('|')) {
          const cells = line.slice(1, -1).split('|').map(c => c.trim())
          // 分隔行 |---|---|
          if (cells.every(c => /^-+$/.test(c))) {
            continue
          }
          if (!inTable) {
            tableHtml = '<table class="md-table">'
            inTable = true
          }
          const tag = (tableHtml.indexOf('<thead') === -1) ? 'th' : 'td'
          if (tag === 'th') {
            tableHtml += '<thead><tr>'
            cells.forEach(c => { tableHtml += `<th>${c}</th>` })
            tableHtml += '</tr></thead><tbody>'
          } else {
            tableHtml += '<tr>'
            cells.forEach(c => { tableHtml += `<td>${c}</td>` })
            tableHtml += '</tr>'
          }
          continue
        } else if (inTable) {
          tableHtml += '</tbody></table>'
          result.push(tableHtml)
          tableHtml = ''
          inTable = false
        }
        result.push(line)
      }
      if (inTable) {
        tableHtml += '</tbody></table>'
        result.push(tableHtml)
      }

      html = result.join('\n')

      // 标题
      html = html.replace(/^### (.+)$/gm, '<h4 class="md-h4">$1</h4>')
      html = html.replace(/^## (.+)$/gm, '<h3 class="md-h3">$1</h3>')
      html = html.replace(/^# (.+)$/gm, '<h3 class="md-h3">$1</h3>')
      // 加粗
      html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      // 列表项
      html = html.replace(/^- (.+)$/gm, '<div class="md-li">• $1</div>')
      // 换行
      html = html.replace(/\n/g, '<br/>')
      // 清理标题后的多余换行
      html = html.replace(/<\/h3><br\/>/g, '</h3>')
      html = html.replace(/<\/h4><br\/>/g, '</h4>')
      html = html.replace(/<br\/><h/g, '<h')
      return html
    },
  }
}
</script>
<style scoped>
@import "../style/design-system.css";

.top { padding-top: 30px; }

/* 截图缩略条 */
.thumb-strip { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 14px; }
.tshot {
  aspect-ratio: 4 / 5;
  border-radius: 8px;
  border: 1px solid rgba(27,25,22,.14);
  background: var(--paper-hi);
  overflow: hidden;
  display: grid; place-items: center;
  position: relative;
  cursor: pointer;
}
.tshot .thumb-img {
  width: 100%; height: 100%; object-fit: cover; border-radius: 6px;
}
.tshot .n {
  position: absolute; bottom: 4px; right: 6px;
  font-size: 9px; color: #fff;
  background: rgba(27,25,22,.5); border-radius: 4px; padding: 1px 4px;
  font-variant-numeric: tabular-nums;
}

/* 问答 */
.qhead { display: flex; align-items: center; gap: 8px; text-align: left; }
.qbox {
  margin-top: 12px;
  background: rgba(27,25,22,.045);
  border-radius: 10px;
  padding: 10px 14px 10px 18px;
  font-size: 13.5px; color: var(--ink-soft); line-height: 1.7;
  text-align: left;
}
.detail-card { text-align: left; }
.qbox::before { content: "问 · "; color: var(--seal-dk); font-family: var(--f-serif); }

.stamp { position: absolute; top: 14px; right: 16px; z-index: 2; }

/* markdown 内容 */
.md { margin-top: 14px; font-size: 14px; color: var(--ink-soft); line-height: 1.9; text-align: left; padding-left: 10px; }
::v-deep .md p { margin-bottom: 8px; }
::v-deep .md h3 {
  font-family: var(--f-serif); font-size: 17px; letter-spacing: .08em;
  color: var(--ink); margin: 14px 0 6px;
}
::v-deep .md h4 { font-size: 14.5px; color: var(--ink); margin: 12px 0 4px; letter-spacing: .05em; }
::v-deep .md strong { color: var(--ink); }
::v-deep .md .md-li { margin-left: 6px; }
::v-deep .md .md-table {
  width: 100%; border-collapse: collapse; margin: 10px 0; font-size: 13px;
}
::v-deep .md .md-table th { border: 1px solid rgba(27,25,22,.14); background: var(--paper-lo); padding: 6px; }
::v-deep .md .md-table td { border: 1px solid rgba(27,25,22,.14); padding: 6px; }

/* 追问 */
.limit-note { margin-top: 12px; font-size: 14px; color: var(--seal-dk); }
.count-note { margin-top: 10px; font-size: 12px; color: var(--ink-mute); text-align: center; letter-spacing: .04em; }

.empty-state { text-align: center; color: var(--ink-mute); font-size: 14px; margin-top: 40px; padding: 40px 0; }

/* 页脚二维码 */
.foot { margin-top: 30px; text-align: center; color: var(--ink-mute); font-size: 12px; letter-spacing: .08em; }
.foot .qr { width: 30%; margin: 0 auto 10px; }

::v-deep .van-button { font-family: var(--f-sans); }
</style>
